import { AuthService } from '../../service/auth.service';
import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AngularFirestore,AngularFirestoreCollection} from '@angular/fire/firestore';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.component.html',
  styleUrls: ['./refund-policy.component.css']
})
export class RefundPolicyComponent implements OnInit {
  image: File;
  refundForm:FormGroup;
  refund_image:any;
  refund_image_url:any ='';
  FOLDER: any = 'refund/';
  loading: any = false;
  edit: any = false;
  id: any;
  error: any = '';
  constructor(private form:FormBuilder,private router:Router ,private afs:AngularFirestore,private auth: AuthService,
    public toastr: ToastsManager,vcr: ViewContainerRef) {
      this.toastr.setRootViewContainerRef(vcr);
     }

  ngOnInit() {
    this.refundForm = this.form.group({
      content: ['', [Validators.required]],
      upload_Image: ['', []]
    });
    this.checkdata();
  }
  async checkdata() {
    try {
      const refunddata = await this.afs.collection('/refund').valueChanges();
      refunddata.subscribe(refunddata => {
        console.log(refunddata);

        if (refunddata.length >= 1) {
          this.refundForm.get('content').setValue(refunddata[0]['heading']);
          this.refund_image_url = refunddata[0]['imageurl'];
          this.edit = true;
          this.id = refunddata[0]['id'];
        }
      });
    } catch (error) {
      this.error = 'Somthing went wrong please try later';
      this.toastr.error('Somthing went wrong please try later', 'Oops!');
      console.log(error);
    }
  }
  changeListner2(event) {
    this.image = <File>event.target.files[0];
  }
  async addrefund(value, valid) {
    this.error = '';
    if (valid || this.edit) {
      this.loading = true;
      try {
        let uploadedimage;
        if (this.edit) {
          if (this.image) {
            uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
            await this.afs.doc('refund/' + this.id).update({ heading: value.content, imageurl: uploadedimage['Location'] });
          } else {
            await this.afs.doc('refund/' + this.id).update({ heading: value.content });
          }
        } else {
          if (!this.image) {
            this.error = 'Image is required';
            this.toastr.error('Image is required!', 'Oops!');
          }
          uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);
          const addrefund = await this.afs.collection('refund')
            .add({ heading: value.content, imageurl: uploadedimage['Location'], type: 'mobile' });
          const id = addrefund.id;
          await this.afs.doc(`/refund/${id}`).update({ id: id });
        }
        this.loading = false;
        this.toastr.success('Refund policy Updated!', 'Success!');

      } catch (error) {
        this.loading = false;
        this.toastr.error('Somthing went wrong please try later!', 'Oops!');
        console.log(error);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/extras/refund-policy/refund-policy.component.ts